import React from "react";
/* Oscar Radar - LED dot-matrix text (5x7 font, rendered as glowing dots) */
const F={
" ":[".....",".....",".....",".....",".....",".....","....."],
"A":[".###.","#...#","#...#","#####","#...#","#...#","#...#"],
"B":["####.","#...#","#...#","####.","#...#","#...#","####."],
"C":[".####","#....","#....","#....","#....","#....",".####"],
"D":["####.","#...#","#...#","#...#","#...#","#...#","####."],
"E":["#####","#....","#....","####.","#....","#....","#####"],
"F":["#####","#....","#....","####.","#....","#....","#...."],
"G":[".####","#....","#....","#..##","#...#","#...#",".###."],
"H":["#...#","#...#","#...#","#####","#...#","#...#","#...#"],
"I":[".###.","..#..","..#..","..#..","..#..","..#..",".###."],
"J":["....#","....#","....#","....#","#...#","#...#",".###."],
"K":["#...#","#..#.","#.#..","##...","#.#..","#..#.","#...#"],
"L":["#....","#....","#....","#....","#....","#....","#####"],
"M":["#...#","##.##","#.#.#","#.#.#","#...#","#...#","#...#"],
"N":["#...#","##..#","#.#.#","#..##","#...#","#...#","#...#"],
"O":[".###.","#...#","#...#","#...#","#...#","#...#",".###."],
"P":["####.","#...#","#...#","####.","#....","#....","#...."],
"Q":[".###.","#...#","#...#","#...#","#.#.#","#..#.",".##.#"],
"R":["####.","#...#","#...#","####.","#.#..","#..#.","#...#"],
"S":[".####","#....","#....",".###.","....#","....#","####."],
"T":["#####","..#..","..#..","..#..","..#..","..#..","..#.."],
"U":["#...#","#...#","#...#","#...#","#...#","#...#",".###."],
"V":["#...#","#...#","#...#","#...#","#...#",".#.#.","..#.."],
"W":["#...#","#...#","#...#","#.#.#","#.#.#","##.##","#...#"],
"X":["#...#","#...#",".#.#.","..#..",".#.#.","#...#","#...#"],
"Y":["#...#","#...#",".#.#.","..#..","..#..","..#..","..#.."],
"Z":["#####","....#","...#.","..#..",".#...","#....","#####"],
"0":[".###.","#...#","#..##","#.#.#","##..#","#...#",".###."],
"1":["..#..",".##..","..#..","..#..","..#..","..#..",".###."],
"2":[".###.","#...#","....#","...#.","..#..",".#...","#####"],
"3":["####.","....#","....#",".###.","....#","....#","####."],
"4":["...#.","..##.",".#.#.","#..#.","#####","...#.","...#."],
"5":["#####","#....","####.","....#","....#","#...#",".###."],
"6":["..##.",".#...","#....","####.","#...#","#...#",".###."],
"7":["#####","....#","...#.","..#..",".#...",".#...",".#..."],
"8":[".###.","#...#","#...#",".###.","#...#","#...#",".###."],
"9":[".###.","#...#","#...#",".####","....#","...#.",".##.."],
".":[".....",".....",".....",".....",".....",".##..",".##.."],
",":[".....",".....",".....",".....",".##..","..#..",".#..."],
":":[".....",".##..",".##..",".....",".##..",".##..","....."],
"-":[".....",".....",".....","#####",".....",".....","....."],
"+":[".....","..#..","..#..","#####","..#..","..#..","....."],
"/":["....#","....#","...#.","..#..",".#...","#....","#...."],
"!":["..#..","..#..","..#..","..#..","..#..",".....","..#.."],
"?":[".###.","#...#","....#","...#.","..#..",".....","..#.."],
"&":[".##..","#..#.","#.#..",".#...","#.#.#","#..#.",".##.#"],
"%":["##..#","##..#","...#.","..#..",".#...","#..##","#..##"],
"'":["..#..","..#..",".#...",".....",".....",".....","....."],
"∞":[".......",".......",".##.##.","#..#..#",".##.##.",".......","......."],
"•":[".....",".....",".###.",".###.",".###.",".....","....."]
};

/**
 * DotMatrix - LED text.  <DotMatrix text="ONLINE 12" dot={3} color="#E3B95E" />
 * dot: pixel pitch of one LED. Off LEDs are drawn dim so it reads as a real panel.
 */
export function DotMatrix({text,dot=3,color="#E3B95E",off="rgba(255,255,255,0.05)",glow=true,flicker=false,style,title}){
  const chars=String(text==null?"":text).toUpperCase().split("");
  let cols=0;const glyphs=chars.map(c=>{const g=F[c]||F["?"];const w=g[0].length;const x=cols;cols+=w+1;return{g,w,x};});
  cols=Math.max(1,cols-1);
  const r=dot*0.47,W=cols*dot,H=7*dot;
  const dots=[];
  glyphs.forEach((gl,gi)=>gl.g.forEach((row,y)=>{for(let x=0;x<gl.w;x++){const on=row[x]==="#";dots.push(<circle key={gi+"-"+y+"-"+x} cx={(gl.x+x)*dot+dot/2} cy={y*dot+dot/2} r={on?r:r*0.7} fill={on?color:off} stroke={on?color:"none"} strokeWidth={on?dot*0.06:0}/>);}}));
  return(
    <svg role="img" aria-label={title||String(text)} width={W} height={H} viewBox={"0 0 "+W+" "+H} style={Object.assign({display:"inline-block",verticalAlign:"middle",overflow:"visible",flexShrink:0,filter:glow?"drop-shadow(0 0 "+(dot*0.5)+"px "+color+"88)":"none",animation:flicker==="rand"?"ledRand 6.5s linear infinite":(flicker?"ledFlicker 4.5s infinite":"none")},style)}>{dots}</svg>
  );
}

export const LED_CSS=`
body{-webkit-font-smoothing:antialiased;text-rendering:geometricPrecision}
img{image-rendering:-webkit-optimize-contrast}
button{-webkit-font-smoothing:antialiased}
@keyframes ledFlicker{0%,100%{opacity:1}92%{opacity:1}93%{opacity:.82}94%{opacity:1}96%{opacity:.9}97%{opacity:1}}
@keyframes ledRand{0%,100%{opacity:1}6%{opacity:1}7%{opacity:.25}8%{opacity:1}9%{opacity:.5}10%{opacity:1}31%{opacity:1}32%{opacity:.15}34%{opacity:.9}35%{opacity:.3}37%{opacity:1}58%{opacity:1}59%{opacity:.4}60%{opacity:1}74%{opacity:1}75%{opacity:.1}76%{opacity:.8}78%{opacity:.2}80%{opacity:1}93%{opacity:1}94%{opacity:.5}95%{opacity:1}}
@keyframes ledScan{0%{transform:translateY(-100%)}100%{transform:translateY(100%)}}
@keyframes ledBlink{0%,100%{opacity:1}50%{opacity:.25}}
@keyframes ledMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
.led-panel{position:relative;overflow:hidden;border-radius:14px;background:linear-gradient(180deg,#07101F,#0B1B33);border:1px solid rgba(198,161,91,0.35);box-shadow:inset 0 0 18px rgba(0,0,0,.6),0 4px 14px rgba(0,0,0,.35)}
.led-panel::after{content:"";position:absolute;inset:0;pointer-events:none;background:repeating-linear-gradient(0deg,rgba(255,255,255,0.035) 0 1px,transparent 1px 3px)}
.led-panel::before{content:"";position:absolute;left:0;right:0;height:38%;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(227,185,94,0.07),transparent);animation:ledScan 5s linear infinite}
`;

/** LedPanel - dark LED display tile with a small caption underneath */
export function LedPanel({value,label,color="#E3B95E",dot=3.4,width,style,flicker=true}){
  return(
    <div className="led-panel" style={Object.assign({padding:"12px 10px 9px",textAlign:"center",minWidth:0,flex:1,width},style)}>
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",minHeight:7*dot,position:"relative",zIndex:1}}><DotMatrix text={value} dot={dot} color={color} flicker={flicker}/></div>
      <div style={{position:"relative",zIndex:1,marginTop:8,fontSize:9,fontWeight:800,letterSpacing:1.6,color:"rgba(247,242,232,0.62)"}}>{label}</div>
    </div>);
}

/** LedTitle - bold digital screen title */
export function LedTitle({text,dot=2.6,color="#F2C14E",style,flicker}){
  const ref=React.useRef(null);
  const[d,setD]=React.useState(dot);
  React.useLayoutEffect(()=>{
    const el=ref.current;if(!el)return;
    const fit=()=>{const w=el.clientWidth-30; // panel padding + border
      const need=String(text).length*6*dot; // 5 cols + 1 gap per glyph
      setD(w>0&&need>w?Math.max(1.2,+(dot*w/need).toFixed(2)):dot);};
    fit();
    let ro;try{ro=new ResizeObserver(fit);ro.observe(el);}catch(e){window.addEventListener("resize",fit);}
    return()=>{try{ro&&ro.disconnect();}catch(e){}window.removeEventListener("resize",fit);};
  },[text,dot]);
  return(<div ref={ref} style={Object.assign({display:"flex",justifyContent:"center",alignItems:"center",flex:"1 1 auto",width:"100%",minWidth:0},style)}>
    <div className="led-panel" style={{display:"inline-flex",alignItems:"center",justifyContent:"center",maxWidth:"100%",padding:"8px 14px 7px",borderRadius:12,border:"1px solid rgba(242,193,78,0.4)",boxSizing:"border-box"}}>
      <div style={{position:"relative",zIndex:1,maxWidth:"100%",overflow:"hidden"}}><DotMatrix text={text} dot={d} color={color} title={text} flicker={flicker}/></div>
    </div></div>);
}

/** ScoreBoard - dark LED panel: radar status, location, and live numbers */
export function ScoreBoard({active,place,cells,onTap}){
  const loc=String(place||"LOCATING...").toUpperCase();
  const ld=Math.max(1,Math.min(1.8,280/(Math.max(1,loc.length)*6)));
  const col=active?"#4ADE80":"#F2C14E";
  return(
    <div className="led-panel" onClick={onTap} style={{margin:"2px 14px 6px",padding:"8px 8px 7px",textAlign:"center",borderRadius:14,border:"1px solid rgba(242,193,78,0.5)",boxShadow:"inset 0 0 22px rgba(0,0,0,.7),0 6px 18px rgba(0,0,0,.4)"}}>
      <div style={{position:"relative",zIndex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:9}}>
        <span style={{width:9,height:9,borderRadius:5,background:col,boxShadow:"0 0 6px "+col,animation:active?"ledBlink 1.6s ease-in-out infinite":"none"}}/>
        <DotMatrix text={active?"RADAR ACTIVE":"RADAR STANDBY"} dot={2} color={col}/>
      </div>
      <div style={{position:"relative",zIndex:1,height:1,margin:"6px 14px",background:"linear-gradient(90deg,transparent,rgba(242,193,78,0.5),transparent)"}}/>
      <div style={{position:"relative",zIndex:1,display:"flex",justifyContent:"center",alignItems:"center",gap:7}}>
        <span style={{fontSize:13}}>{"📍"}</span>
        <DotMatrix text={loc} dot={ld} color="#F2C14E"/>
      </div>
      <div style={{position:"relative",zIndex:1,display:"grid",gridTemplateColumns:"repeat("+cells.length+",1fr)",gap:5,marginTop:8}}>
        {cells.map((c,i)=>(
          <div key={i} style={{padding:"5px 2px",borderRadius:9,background:"rgba(255,255,255,0.03)",border:"1px solid "+c.color+"44",display:"flex",flexDirection:"column",alignItems:"center",gap:4,minWidth:0}}>
            <DotMatrix text={c.label} dot={1} color={c.color} glow={false} style={{opacity:.85}}/>
            <DotMatrix text={String(c.value)} dot={c.value&&String(c.value).length>4?1.7:2.1} color={c.color}/>
          </div>))}
      </div>
    </div>);
}
